const XIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={7}
      height={7}
      viewBox="0 0 9 9"
      fill="none"
      overflow="visible"
    >
      <path
        stroke="#FAFAFA"
        strokeLinecap="round"
        strokeWidth={2}
        d="M8 8L1 1M8 1L1 8"
      />
    </svg>
  )
}

export default XIcon;
